import React, {Component} from 'react'
import {Input, Button} from "antd"
import ModalResults from "./ModalResults"
import {retryOrderPrintedFile, retryPrintedFileSession} from "../../../services/api/3dApi"
import * as lodash from "lodash"

const {TextArea} = Input

class ReGenerateItems extends Component {
    state = {
        loading: false,
        value: '',
        showModal: false,
        error: '',
        data: [],
        session_id: null,
        isErrorAll: false,
        listErrorRetry: [],
    }

    closeModal = () => {
        this.setState({
            showModal: false,
        }, () => {
            this._handleClear()
        })
    }

    _handleChange = e => {
        const {value} = e.target
        this.setState({
            value,
            error: ''
        })
    }

    _handleSubmit = e => {
        e.preventDefault()

        this._handleGenItems()
    }

    _handleGenItems = async (session_id = null, listErrorRetry = []) => {
        try {
            this.setState({
                error: '',
                loading: true
            })

            const {value} = this.state
            const arr = value.split(/\r|\n|\t|\r\n|\s|,\s|,/)
            const arrItems = arr.filter(item => item !== '' && /^#\d+_/.test(item))

            const payload = {
                orderNumbers: listErrorRetry.length > 0 ? listErrorRetry : arrItems,
                session_id: session_id || ''
            }

            const {data: response} = await retryOrderPrintedFile(payload)
            const {data, success, error} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error
                })
            }

            const newData = data.filter(o => o.queue_job)
            const isErrorAll = newData.every(item => !!item && lodash.get(item, 'queue_job.status') === 'error')

            //list các items có trạng thái done hoặc error
            const listItemFinish = newData.filter(item => !!item && (lodash.get(item, 'queue_job.status') === 'error' || lodash.get(item, 'queue_job.status') === 'done')) || []
            const isOnlyErrorItem = listItemFinish.every(item => !!item && lodash.get(item, 'queue_job.status') === 'error')

            if(isOnlyErrorItem){
                this.setState({
                    data : newData,
                    session_id: newData[0].queue_job.session_id,
                    showModal: true,
                    loading: false,
                    isErrorAll,
                    listErrorRetry: [],
                })
            }else{
                const listErrorRetry = listItemFinish.map(item => {
                    if(!!item && lodash.get(item, 'queue_job.status') === 'error') return '#' + lodash.get(item, 'barcode_number')
                }).filter(i => i)

                this.setState({
                    data : newData,
                    session_id: newData[0].queue_job.session_id,
                    showModal: true,
                    loading: false,
                    isErrorAll,
                    listErrorRetry
                })
            }
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    _hanldeRetryPrintFileSession = async () => {
        try {
            this.setState({
                error: '',
                loading: true
            })

            const {session_id} = this.state

            const {data: response} = await retryPrintedFileSession({session_id})
            const {data, success, error} = response

            if (!success) {
                return this.setState({
                    error
                })
            }
            const newSessionId = !!data[0] && data[0].session_id
            this._handleGenItems(newSessionId)

        } catch (e) {
            this.setState({
                error: e.message,
            })
        }finally{
            this.setState({loading: false})
        }
    }

    _handleClear = () => {
        this.setState({
            loading: false,
            value: '',
            showModal: false,
            error: '',
            data: [], 
            isErrorAll: false,
            listErrorRetry: []
        })
    }

    render() {
        const {value, error, loading, showModal, data, session_id, isErrorAll, listErrorRetry} = this.state

        return (
            <div className="ReGenerateItems">
                <div className="d-flex align-items-baseline justify-content-between">
                    <h1 className="PageTitle">Gen lại file in Items</h1>
                </div>
                <div className="site-layout-background">
                    <TextArea
                        onChange={this._handleChange}
                        style={{fontSize: 40}}
                        value={value}
                        placeholder='Nhập items cần quét '
                    />
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            {error && (
                                <div className="mt-3 text-danger">{error}</div>
                            )}
                        </div>
                        <div className="d-flex justify-content-end align-items-center">
                            {
                                value && <Button size="large" type='default' className='mt-3'
                                                 onClick={this._handleClear}
                                >
                                    Xóa
                                </Button>
                            }
                            <Button loading={loading} size="large" type='primary' className='ml-3 mt-3'
                                    onClick={this._handleSubmit}
                            >
                                Gen lại file in Items
                            </Button>
                        </div>
                    </div>
                </div>
                {showModal && (
                    <ModalResults 
                        loading={loading} 
                        showModal={showModal} 
                        closeModal={this.closeModal} 
                        data={data}
                        onRefresh={this._handleGenItems} 
                        session_id={session_id} 
                        error={error} 
                        isErrorAll={isErrorAll}
                        onRetryPrintFileSession={this._hanldeRetryPrintFileSession}
                        listErrorRetry={listErrorRetry}
                    />
                )}
            </div>
        )
    }

}

export default ReGenerateItems
